const variables = {
  // new colors
  cobaltBlue: '#869FE8',
  grey: '#C6C9D2',
  background: '#FAFAFA',
  cadetBlue: '#A9ADB9',
  cultured: '#F4F4F4',
  ghostWhite: '#F9F9F9',
  white: '#FFFFFF',
  black: '#222222',
  red: '#FA2742',
  boxShadow: '#677eac29',
  davyGrey: '#5a5a5a',
  abalonGrey: '#e4e6ed',
  fossilGrey: '#505050',
  chineseWhite: '#e1e1e1',
  lineGraphOrange: '#EECF8F',
  lineGraphText: '#818181',
  error: '#FF3730',
  darkPastelRed: '#b74924',
  lavander: '#E5ECF6',
  oceanGreen: '#5CC99C',
  orchid: '#DD6DE7',
  yellowRed: '#FBBE3F',
  ultramarineBlue: '#3467F4',
  policeBlue: '#354665',
  shadowBlue: '#718BAE',
  brightGrey: '#ecedf1',
  lavanderGhostWhite: '#f6f8fc',
  spanishGrey: '#95909b',
  gray: '#808080',
  greyLight: '#FAFAFA',
  black50: '#030C2180',
  richBlack: '#030C21',
  mintWhite: '#ECF5F2',
  beige: '#F7F9DC',
  nyanza: '#E2F5E1',
  purpleWhite: '#F2EBFB',
  blueishWhite: '#EBF3F7',
  black20: '#030C2133',
  black10: '#030C211A',
  black5: '#030C210D',
  desire: '#f04951',
  americanPink: '#FF8F94',
  mediumSeaGreen: '#3BBB7A',
  cyan: '#37CEFF',
  violet: '#B385EF',

  // breakpoints
  xl: 1920,
  lg: 1280,
  md: 960,
  sm: 600,
  xs: 0,

  // spacing
  spacing: 6,
};

export default variables;
